import needHelpImg from "@assets/need-help-banner.png";
import ButtonVariants from "@core-components/button/ButtonVariants";
import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import { BackgroundImage, Stack } from "@mantine/core";

import useAppTranslation from "@hooks/language/useAppTranslation";

interface INeeHelpBannerProps {
  background?: string;
}

const NeedHelpBanner: React.FC<INeeHelpBannerProps> = ({ background }) => {
  const { t } = useAppTranslation("common.helpBanner");
  return (
    <Stack align="center" className=" hover-scale w-full" justify="center">
      <BackgroundImage
        className="flex justify-center bg-[60%] "
        radius={12}
        src={background ?? needHelpImg}
      >
        <div className="flex w-full flex-col items-start justify-between gap-5 p-5 sm:flex-row sm:items-center md:px-9 md:py-7">
          <Stack className="flex-1" gap={0}>
            <SSHeadline props={{ stack: { align: "left" } }}>
              <SSWhiteText className="text-[25px] md:text-[35px]">
                {t("title")} <Emoji.Handshake size={40} />
                <br /> {t("subtitle")}
              </SSWhiteText>
            </SSHeadline>
          </Stack>
          <ButtonVariants.HelpBanner />
          <ButtonVariants.LiveChat />
        </div>
      </BackgroundImage>
    </Stack>
  );
};

export default NeedHelpBanner;
